import { type ProductKeys1P } from '../../../common/constants/types';
import { FirstPartyConfigs } from '../../../common/ui/first-party';

/**
 * @internal Only for use by `coerceFirstPartyFriendlyName`.
 *
 * Name-only fallbacks for first-party products that have **no** entry in
 * {@link FirstPartyConfigs} (which is keyed by {@link ProductKeys1P}).
 *
 * TODO RAOC23: Migrate these into FirstPartyConfigs
 * TODO RAOC23: improve downstream code sites so these can be i18n (goals, projects should be translated). conversation-assistant-store does not implement i18n today for these, so there is no new regression from this code
 */
const FIRST_PARTY_FRIENDLY_NAME_FALLBACKS: Readonly<Record<string, string>> = {
	loom: 'Loom',
	goal: 'Goals',
	project: 'Projects',
};

/**
 * @internal Only for use by `useRovoConfigStore`.
 *
 * Resolves a human-readable name for a first-party (1P) product key.
 */
export const coerceFirstPartyFriendlyName = (productKey: string): string => {
	const config = FirstPartyConfigs[productKey as ProductKeys1P];
	if (config?.displayName) {
		return config.displayName;
	}

	return FIRST_PARTY_FRIENDLY_NAME_FALLBACKS[productKey] ?? '';
};
